import styled from 'styled-components';

export const StatusIcon = styled.span`
    &.status-missing {
        color: orangered;
    }
    &.status-unsaved {
        color: transparent;
    }
    &.status-saved {
        color: #aaaaaa;
    }
    &.status-edited {
        color: #6d98ba;
    }
    &.status-completed {
        color: #f5ab23;
    }
    &.status-approved {
        color: #107c10;
    }
    &.status-tankers-event-mismatch {
        color: #873a45;
    }
    &.status-incomplete {
        color: orange;
    }
    &.status-error {
        color: #dc3545;
    }
`;
